import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { LOCALE_ID, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { JwtModule } from '@auth0/angular-jwt';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDatepickerModule, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { esLocale } from 'ngx-bootstrap/locale';
import { TagInputModule } from 'ngx-chips';
import { NgxSpinnerModule } from 'ngx-spinner';
import { ToastrModule } from 'ngx-toastr';
import { PdfMakeWrapper } from 'pdfmake-wrapper';
import { environment } from 'src/environments/environment';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing';
import { GraphQLModule } from './core/graphql.module';
import { AdminLayoutComponent } from './core/layouts/admin-layout/admin-layout.component';
import { AuthLayoutComponent } from './core/layouts/auth-layout/auth-layout.component';
import { ComponentsModule } from './core/layouts/components/components.module';
import { PublicLayoutComponent } from './core/layouts/public-layout/public-layout.component';
import { AuthModule } from './pages/auth/auth.module';
import { ROOT_REDUCERS } from './pages/auth/state/app.state';
import { HttpInterceptorService } from './shared/services/http-interceptor.service';


export function jwtTokenGetter() {
  return localStorage.getItem('jwt');
}
@NgModule({ declarations: [
        AppComponent,
        AdminLayoutComponent,
        AuthLayoutComponent,
        PublicLayoutComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        FormsModule,
        RouterModule,
        ComponentsModule,
        BsDropdownModule,
        AppRoutingModule,
        ToastrModule.forRoot(),
        CollapseModule,
        TagInputModule,
        BrowserModule,
        AppRoutingModule,
        GraphQLModule,
        NgxSpinnerModule,
        AuthModule,
        BsDatepickerModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: jwtTokenGetter,
                allowedDomains: [`${environment.apiUrl}`],
                disallowedRoutes: [`${environment.apiUrl}/api/admin/*`],
            },
        }),
        StoreModule.forRoot(ROOT_REDUCERS),
        StoreDevtoolsModule.instrument({ name: 'IEEG-STORE' })], providers: [
        PdfMakeWrapper,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpInterceptorService,
            multi: true,
        },
        { provide: LOCALE_ID, useValue: 'es-MX' },
        provideHttpClient(withXhr(), withInterceptorsFromDi()),
    ] })
export class AppModule {
  constructor(private localeService: BsLocaleService) {
    defineLocale('es', esLocale);
    this.localeService.use('es');
  }
}
